export default "__VITE_ASSET__CtEWxE$h__"